import React from 'react';
import styles from './styles.css';

const Indonesia = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <ol type="I">
        <p>
          <b>Perjanjian Merchant Kredivo (“Layanan/ Layanan-Layanan”)</b>
        </p>
        <p>
          Peraturan dan kesanggupan yang dinyatakan di bawah ini berlaku atas
          entitas-entitas dan individu-individu (secara bersama-sama disebut
          sebagai "<b>Merchant/Para Merchant</b>") yang telah mendaftar untuk
          menggunakan Kredivo Checkout (produk PT FinAccel Teknologi Indonesia)
          baik secara langsung dengan Kredivo maupun secara tidak langsung
          melalui pihak ketiga (contohnya penyedia platform Merchant, "
          <b>Mitra</b>") untuk penjualannya di Indonesia. Penggunaan Kredivo
          Checkout, dan oleh karenanya persetujuannya terlebih dahulu atas
          peraturan-peraturan ini (termasuk Persyaratan dan Ketentuan Umum ("
          <b>PKU</b>")) menciptakan hubungan kontraktual langsung (bersama
          dengan persyaratan apa pun yang disetujui dengan Kredivo atau dengan
          Mitra atas nama Kredivo, “Perjanjian”) antara setiap Merchant dan
          Kredivo (secara bersama-sama disebut sebagai "<b>Para Pihak</b>").
        </p>
        <ol type="1">
          <li>
            <b>Latar belakang dan cakupan kerja sama</b>
            <p>
              PT FinAccel Teknologi Indonesia (“Kredivo”) adalah suatu
              perusahaan yang menyediakan metode pembayaran kepada Merchant yang
              melakukan penjualan online, offline dan melalui jalur-jalur
              penjualan lainnya. Kredivo Checkout adalah solusi checkout di
              belakang dan angsuran untuk merchant online dan offline
              (“KredivoCheckout”). Merchant mengoperasikan suatu toko online
              dari alamat web/URL/toko aplikasi Android (“E-store”) atau
              jaringan ritel yang terdaftar sesuai peraturan dan
              perundang-undangan berlaku di negara tempat beroperasi (“Jaringan
              Ritel”). Merchant dapat mengintegrasikan Kredivo Checkout ke dalam
              E-store, Jaringan Ritel atau jalur pembelian lainnya sebagaimana
              telah disetujui antara Para Pihak sehingga pelanggan Merchant
              dapat membayar melalui Kredivo Checkout. Integrasi tersebut dapat
              dilakukan oleh Merchant sendiri atau menggunakan pihak ketiga.
            </p>
            <p>
              Para Pihak dengan ini setuju untuk memasukkan Kredivo Checkout ke
              dalam E-store, Jaringan Ritel atau jalur pembelian yang telah
              disetujui lain apa pun untuk negara-negara yang dispesifikasikan
              melalui perjanjian antara Merchant dan Mitra yang memberikan
              Layanan kepada Merchant atau yang diatur secara langsung antara
              Merchant dan Kredivo, dan berkomitmen untuk bekerja sama untuk
              mempersiapkan dan menyediakan Layanan-Layanan.
            </p>
          </li>
          <li>
            <b>Pembelian melalui Kredivo Checkout</b>
            <p>
              Pembelian oleh pelanggan melalui Kredivo Checkout dilakukan dengan
              cara berikut: Seorang pelanggan yang bermaksud untuk membeli
              sekarang dan membayar nanti terkait pembelian di E-store atau
              melalui jalur pembelian lain yang disetujui memasuki Kredivo
              Checkout setelah memilih barang atau jasa yang akan dibeli. Jika
              pelanggan belum menjadi pengguna Kredivo, ia perlu mengunduh
              aplikasi Kredivo atau mendaftar melalui antarmuka web dan
              menyelesaikan proses aplikasi. Jika pelanggan adalah pengguna
              Kredivo yang telah disetujui, pelanggan memasuki akunnya.
              Berdasarkan informasi ini, Kredivo Checkout menilai apakah batas
              kredit yang cukup tersedia bagi pelanggan untuk melanjutkan
              pembelian. Setelah penilaian difinalisasi: jika ya, pelanggan
              melakukan check out dan setuju untuk membayar kembali Kredivo
              dalam 30 hari (tanpa angsuran) atau lebih (dengan angsuran); jika
              tidak: pelanggan diberitahukan bahwa checkout melalui Kredivo
              tidak dapat dilakukan dan ia harus menggunakan metode pembayaran
              alternatif (pelanggan tersebut selanjutnya disebut sebagai seorang
              "<b>Pelanggan</b>").
            </p>
          </li>
          <li>
            <b>Akuisisi klaim oleh Kredivo</b>
            <p>
              Setelah finalisasi pembelian oleh Pelanggan, reservasi atas jumlah
              terkait dibuat dalam sistem transaksi usaha Kredivo ("
              <b>Sistem Pemantauan Pemesanan Kredivo</b>") yang aksesnya
              diberikan oleh Kredivo kepada Merchant, atau Mitra (atas nama
              Merchant) untuk memberikan Layanan. Kredivo berjanji untuk
              mengakuisisi klaim Merchant terhadap Pelanggan (disebut sebagai
              “Klaim”) berdasarkan persyaratan dan ketentuan yang ditetapkan
              dalam Perjanjian ini. Kredivo mengakuisisi Klaim pada saat yang
              sama ketika transaksi untuk membeli dilengkapi antara Merchant dan
              Pelanggan ("<b>Aktivasi</b>"). Setelah akuisisi Klaim, Kredivo
              membayar kepada Merchant pelunasan berdasarkan yang ditetapkan di
              bawah. Hubungan antara Kredivo dan Pelanggan diatur oleh
              perjanjian antara Kredivo dan Pelanggan.
            </p>
          </li>
          <li>
            <b>Pembayaran dan Biaya Transaksi</b>
            <p>
              Kredivo membayar kepada Merchant, setelah pemotongan Biaya
              Transaksi (sebagaimana diartikan di bawah) dan klaim lain yang
              dapat dikenakan oleh Kredivo berdasarkan Perjanjian ini, sesuai
              dengan waktu yang telah disetujui. Pembayaran dibuat kepada
              rekening bank yang diberikan oleh Merchant untuk negara terkait.
              Setiap Pihak menanggung biaya pemindahbukuan banknya sendiri (jika
              ada). Atas penyediaan Layanannya, Kredivo berhak untuk mengenakan
              harga dan biaya yang disetujui antara Para Pihak terkait negaranya
              masing-masing (“Biaya Transaksi”). Setiap Biaya Transaksi dan
              klaim lain yang dimiliki Kredivo berdasarkan Perjanjian ini
              diberikan belum mencakup Pajak Penjualan atau Pajak Jasa atau
              Pajak Pertambahan Nilai, jika pajak tersebut berlaku. Dalam hal
              Merchant mengalami perubahan Mitra, Kredivo memiliki hak untuk
              mengenakan Biaya Transaksi berdasarkan apa yang telah disetujui
              antara Merchant dan mitra barunya atau sesuai dengan penetapan
              harga standar Kredivo (yang mungkin berbeda tergantung dari
              segmen, volume, keuangan Merchant dll).
            </p>
          </li>
          <li>
            <b>Ketentuan spesifik untuk Kredivo Checkout</b>
            <p>
              Hak dan kewajiban Para Pihak ditetapkan secara rinci dalam PKU,
              yang dinyatakan di bawah ini dan juga diberikan kepada Merchant
              atas permintaan.
            </p>
          </li>
          <li>
            <b>Jangka waktu perjanjian</b>
            <p>
              Kecuali disetujui lain (setiap perjanjian efektif sebelumnya
              antara Para Pihak terkait Kredivo Checkout berlaku dengan kekuatan
              lebih tinggi), Perjanjian ini berlaku sejak tanggal penggunaan
              pertama kali oleh Merchant atas Layanan-Layanan berdasarkan
              Perjanjian ini dan terus berlaku hingga pengakhiran oleh salah
              satu Pihak, dengan memberikan pemberitahuan satu (1) bulan
              sebelumnya). Tanpa mengesampingkan ketentuan di atas, Kredivo
              memiliki hak untuk, kapan pun, tanpa peringatan sebelumnya
              membatalkan Perjanjian Merchant dengan Kredivo dan berhenti
              memberikan Layanan jika ada pelanggaran PKU.
            </p>
          </li>
        </ol>
        <p>
          <b>Persyaratan & Ketentuan Umum</b>
        </p>
        <p>
          Persyaratan dan ketentuan umum yang ditetapkan di bawah ini disebut
          sebagai "<b>PKU</b>". Definisi dan istilah yang digunakan dalam bagian
          utama, kecuali secara jelas dinyatakan lain, memiliki arti yang sama
          dalam PKU.
        </p>
        <ol type="1">
          <li>
            <b>Tanggung Jawab Umum Kredivo</b>
            <ol type="a">
              <li>
                Kredivo bertanggung jawab atas semua kendali kredit, pendanaan,
                administrasi dan layanan pelanggan terkait Layanan. Terkait
                Klaim yang diakuisisi, Kredivo akan mengurus penagihan dan
                administrasi apa pun. Semua kegiatan di atas dapat dilakukan
                oleh Kredivo bekerja sama dengan pihak ketiga.
              </li>
              <li>
                Kredivo menanggung risiko kredit dan risiko penipuan atas Klaim,
                kecuali untuk kejadian-kejadian yang ditetapkan dalam bagian 3.
                Dalam kejadian di mana Kredivo menanggung risiko kredit, Kredivo
                akan mengkompensasi Merchant sepenuhnya untuk jumlah keseluruhan
                Klaim tidak termasuk pajak.
              </li>
              <li>
                Kredivo memberikan persyaratan dan ketentuan dan informasi untuk
                diungkapkan oleh Merchant terkait Layanan-Layanan Kredivo
                terkait Pelanggan sebelum, sehubungan dengan dan setelah
                pembelian ("<b>Persyaratan dan Ketentuan Pelanggan</b>").
                Kredivo dapat, atas keputusannya sendiri, mengubah Persyaratan
                dan Ketentuan Pelanggan dan setiap material terkait Pelanggan
                lain apa pun (seperti kontrak, formulir atau informasi terkait
                Layanan). Kredivo memastikan bahwa Persyaratan dan Ketentuan
                Pelanggan sesuai dengan setiap peraturan perundang-undangan
                berlaku.
              </li>
              <li>
                Kecuali disetujui sebaliknya, Kredivo akan, setelah menerima
                pemberitahuan elektronik atasnya dari Merchant tentang
                keberhasilan transaksi, mengirimkan tagihan kepada Pelanggan
                melalui E-mail, sms atau notifikasi dalam aplikasi atau gabungan
                dari ketiganya. Terkait Kredivo Checkout, tagihan dan
                pemberitahuan terkait pembayaran lain kepada Pelanggan selalu
                dibuat oleh Kredivo. Dalam setiap hal, Kredivo selalu memutuskan
                atas pertimbangannya sendiri setiap informasi yang
                dikirim/termaktub dalam tagihan dan pemberitahuan terkait
                pembayaran lainnya.
              </li>
            </ol>
          </li>
          <li>
            <b>Tanggung Jawab Umum Merchant</b>
            <ol type="a">
              <li>
                Merchant harus menampilkan logo Kredivo. Terkait kegiatan
                pemasaran lain yang mencakup rujukan kepada Kredivo atau
                Layanan, Merchant akan mengkoordinasikan kegiatan tersebut
                dengan Kredivo sebelumnya dengan menghubungi Kredivo di
                marketing@kredivo.com. Ketika menggunakan Layanan, Merchant akan
                memenuhi dan mematuhi setiap peraturan perundang-undangan yang
                berlaku dan ketentuan dan pedoman lain yang dikeluarkan oleh
                otoritas publik manapun.
              </li>
              <li>
                Merchant berjanji untuk mengikuti instruksi Kredivo terkait
                integrasi Layanan (contohnya dalam pedoman integrasi Kredivo
                yang dapat dilihat di https://doc.Kredivo.com, "
                <b>Pedoman Integrasi</b>") dan memastikan bahwa setiap saat
                pihaknya menjaga persyaratan teknis yang diperlukan pihaknya
                untuk memungkinkan penggunaan Layanan.
              </li>
              <li>
                Merchant harus memberikan kepada Kredivo informasi yang
                diperlukan Kredivo untuk memberikan Layanan contohnya informasi
                yang diperlukan oleh Kredivo untuk mengidentifikasi Pelanggan.
              </li>
              <li>
                Merchant harus memberikan kepada Pelanggan Persyaratan dan
                Ketentuan Pelanggan dan memastikan bahwa Pelanggan
                mengkonfirmasi penerimaannya. Rincian tersedia dalam Pedoman
                Integrasi. Lebih lanjut, Merchant berkewajiban untuk menampilkan
                alamat kedudukan permanennya, kebijakan privasinya di E-Store
                dan alamat E-mail layanan pelanggan yang aktif dan nomor telepon
                layanan pelanggan di E-Store.
              </li>
              <li>
                Merchant tidak berhak untuk menggunakan formulir tagihannya
                sendiri terkait Pelanggan.
              </li>
              <li>
                Merchant akan diberikan akses kepada laporan transaksi harian
                dan/atau Sistem Pemantauan Pesanan Kredivo. Merchant bertanggung
                jawab atas log-in mereka masing- masing dan setiap tindakan yang
                dilakukan ketika detail log-in digunakan.
              </li>
            </ol>
          </li>
          <li>
            <b>Pengembalian Klaim</b>
            <p>
              Kredivo memiliki hak untuk mengembalikan Klaim kepada Merchant
              dalam hal berikut, dan oleh karenanya juga memiliki hak atas
            </p>
            <ol type="a">
              <li>
                Klaim di mana pengiriman barang atau jasa belum dilakukan sama
                sekali, telah ditunda secara tidak wajar atau dilakukan ke
                alamat selain yang disetujui oleh Kredivo atau dispesifikasikan
                oleh Pelanggan pada saat pembelian terkait.
              </li>
              <li>
                Jika Pelanggan memiliki hak untuk mengurangi akun klaim balik
                terhadap Merchant atau hak atas diskon atau pengurangan lain.
              </li>
              <li>
                Jika ada sengketa atau keberatan antara Merchant dan Pelanggan
                terkait Klaim dan sengketa atau keberatan tersebut tidak
                didasari ketidakmauan atau ketidakmampuan untuk membayar. Suatu
                sengketa bisa saja contohnya ketika barang atau jasa dituduh
                tidak sesuai atau tidak dikirim seluruhnya.
              </li>
              <li>
                Klaim terkait orang atau badan hukum yang dapat secara wajar
                dianggap memiliki kepentingan finansial yang sama dengan
                Merchant, termasuk, namun tidak terbatas pada, suatu perusahaan
                yang berafiliasi dengan Merchant, pemilik atau karyawan Merchant
                dan/atau perusahaan afiliasinya. Sub bagian (d) hanya berlaku
                jika Merchant memiliki kurang dari tiga puluh (30) karyawan.
              </li>
              <li>
                Klaim yang sehubungan dengannya Pelanggan mendapatkan uang
                tunai, cek atau wesel dari Merchant.
              </li>
              <li>
                Klaim di mana Pelanggan bersikeras belum menerima barang, atau
                jika tidak jelas siapa yang menerima barang/jasa tersebut.
              </li>
              <li>
                Klaim di mana Merchant tidak memenuhi persyaratan berdasarkan
                bagian 4 dan 5 di bawah ini, atau di mana Merchant sehubungan
                dengan penagihan, Aktivasi atau lainnya melanggar Perjanjian.
              </li>
              <li>
                Klaim di mana Pelanggan telah membeli suatu produk yang tidak
                tercakup/disetujui dalam kebijakan checkout Kredivo (pengunduhan
                digital, senjata api, senjata tajam, obat-obatan, pornografi dan
                barang ilegal lain berdasarkan hukum negara setempat serta
                kegiatan usaha yang mengandung unsur pelanggaran politik,
                social, moral, maupun suku, agama, dan ras).
              </li>
              <li>
                Klaim yang terkait hal itu Merchant menetapkan persyaratan dan
                ketentuan terkait Pelanggan yang tidak sesuai dengan persyaratan
                dan ketentuan yang diberikan oleh Kredivo atau jika Merchant
                memiliki persyaratan yang telah disetujui dengan Pelanggan yang
                tidak sesuai dengan apa yang telah dikomunikasikan dengan
                Kredivo.
              </li>
            </ol>
          </li>
          <li>
            <b>Tanggung Jawab Para Pihak terkait Klaim</b>
            <ol type="a">
              <li>
                Merchant tidak dapat tanpa persetujuan tertulis Kredivo memasuki
                suatu perjanjian atau kesepakatan dengan pihak ketiga manapun
                terkait pembelian, penggadaian atau pembayaran Klaim, dan tidak
                dapat memasuki kesepakatan lain apa pun yang membatasi hak untuk
                mengalihkan Klaim. Merchant tidak dapat menyetujui perjanjian
                dengan Pelanggan di negara lain selain yang telah disetujui
                dalam kontrak atau dalam mata uang lain dari yang berlaku atas
                masing-masing negara.
              </li>
              <li>
                Jika pembayaran dilakukan langsung oleh Pelanggan atau pihak
                ketiga kepada Merchant, hal ini harus langsung dikomunikasikan
                kepada Kredivo. Merchant harus langsung mengalihkan jumlah
                tersebut kepada Kredivo dan menspesifikasikan untuk apa
                pembayaran itu dibuat. Sebagai alternatif, utang Merchant dapat
                dibayarkan terhadap Klaim lain.
              </li>
              <li>
                Setelah akuisisi Klaim oleh Kredivo, Merchant harus
                menginformasikan kepada Kredivo segera jika Merchant telah
                menyetujui kepada Pelanggan pengembalian barang/jasa atau
                pemotongan harga pembelian, atau jika Pelanggan telah
                menggunakan hak pengembalian/pembatalan yang ditetapkan secara
                hukum.
              </li>
              <li>
                Merchant harus menjawab pertanyaan Kredivo terkait Klaim tanpa
                penundaan yang tidak perlu. Para Pihak harus secara spesifik
                memberitahu satu sama lain jika seorang Pelanggan menyengketakan
                kewajiban untuk melunasi Klaim. Merchant berjanji untuk
                menangani keluhan segera dan secara tepat. Merchant harus
                memberitahu Kredivo jika suatu keluhan tidak diselesaikan dalam
                satu (1) bulan setelah penerimaan.
              </li>
              <li>
                Terkait Kredivo Checkout, Merchant tidak berhak untuk mengenakan
                biaya apa pun atau harga yang lebih tinggi untuk barang atau
                jasa dengan alasan pembelian dilakukan melalui Kredivo Checkout,
                atau, untuk melakukan tindakan diskriminatif apa pun atas
                Kredivo dengan cara apa pun.
              </li>
              <li>
                Merchant bertanggung jawab atas pemenuhan kewajibannya
                berdasarkan hubungan kontraktual dengan Pelanggan dan/atau
                berdasarkan hukum berlaku apa pun. Merchant tidak berhak untuk
                menggunakan Layanan terkait transaksi yang dianggap ilegal
                berdasarkan hukum berlaku apa pun atau yang melanggar instruksi
                Kredivo.
              </li>
              <li>
                Para Pihak setuju bahwa bersama-sama dengan Klaim semua jaminan
                terkait Klaim juga harus dialihkan kepada Kredivo, seperti
                contohnya setiap retensi hak kepemilikan atas barang yang
                diberikan. Dalam hal pengalihan kembali suatu Klaim, jaminan
                yang telah dialihkan tersebut juga dialihkan kembali.
              </li>
            </ol>
          </li>
          <li>
            <p>
              Ketentuan spesifik mengenai pembelian atau pemberian barang di
              toko fisik Kecuali Merchant mengoperasikan Jaringan Ritel saat
              menandatangani Perjanjian ini, Merchant tidak berhak untuk
              menggunakan Layanan untuk penjualan barang di toko fisik. Barang
              yang dibeli melalui Layanan dapat diberikan kepada Pelanggan di
              toko fisik Merchant. Jika Merchant telah mengintegrasikan Kredivo
              Checkout pada Jaringan Ritelnya, maka Merchant bertanggungjawab
              atas kerusakan (perbaikan dan penggantian) perangkat keras fisik
              manapun (misalnya, mesin EDC) yang disediakan oleh Kredivo atau
              penjual yang berafiliasi dengan Kredivo. Struktur biaya untuk
              perbaikan dan penggantian adalah sebagai berikut: <br />
              Penggantian EDC Terminal: Rp 4.500.000 <br />
              Printer cover: Rp 200.000 <br />
              Adaptor: Rp 350.000 <br />
              Adaptor cable: Rp 250.000 <br />
              LCD: Rp 1.000.000 <br />
              Keypad: Rp 200.000 <br />
              Roller Printer: Rp 350.000 <br />
              Biaya servis untuk setiap perbaikan: Rp 150.000 <br />
              Kredivo kiranya dapat memperbarui biaya tersebut sewaktu-waktu.
            </p>
          </li>
          <li>
            <b>Batas kredit</b>
            <p>
              Kredivo akan atas keputusannya sendiri menetapkan batas kredit
              untuk setiap Pelanggan. Kredivo memiliki hak untuk mengubah batas
              kredit tersebut kapan pun.
            </p>
          </li>
          <li>
            <b>Dukungan Modul</b>
            <p>
              Kredivo bertujuan untuk mendukung semua modul dan API yang
              digunakan oleh Merchant untuk terkoneksi dengan Sistem Pemantauan
              Pesanan Kredivo. Akan tetapi, seiring perkembangan teknologi,
              Kredivo memiliki hak untuk menentukan atas keputusannya sendiri
              modul dan API apa yang akan didukung. Jika Kredivo pada satu waktu
              membatalkan dukungan modul atau API tertentu, Kredivo akan
              terlebih dulu memberikan pemberitahuan tiga (3) bulan sebelumnya.
              Informasi mengenai modul dan API apa yang didukung oleh Kredivo
              dapat dilihat di http://doc.kredivo.com.
            </p>
          </li>
          <li>
            <b>Tanggung jawab untuk menginformasikan</b>
            <p>
              {' '}
              Untuk, antara lain, tujuan anti pencucian uang ("<b>APU</b>"),
              Merchant harus memberitahukan segera kepada Kredivo:{' '}
            </p>
            <ol type="a">
              <li>
                mengenai keadaan sehubungan dengan Merchant dan pemiliknya, yang
                mungkin penting bagi penilaian atas status keuangan Merchant;
              </li>
              <li>
                mengenai perubahan terkait alamat Merchant, manajemennya, dewan
                atau APU serta perubahan terkait atas struktur kepemilikan;
              </li>
              <li>
                jika ada perubahan material apa pun terkait jenis produk atau
                jasa yang diberikan oleh Merchant atau jika nama di mana
                Merchant melaksanakan usaha berubah; atau
              </li>
              <li>
                jika ada perubahan material lain terkait Merchant atau
                kegiatannya.
              </li>
            </ol>
          </li>
          <li>
            <b>Pengakhiran</b>
            <p>
              Setiap Pihak memiliki hak untuk mengakhiri Perjanjian berlaku
              segera jika:{' '}
            </p>
            <ol type="a">
              <li>
                Pihak lainnya secara material melanggar ketentuan apa pun dari
                Perjanjian; Pihak lainnya berulang kali atau terus menerus gagal
                memenuhi kewajibannya berdasarkan Perjanjian ini dan tidak atas
                permintaan Pihak lainnya memperbaiki kegagalan tersebut dalam
                batas waktu yang diberikan oleh Pihak lain tersebut;
              </li>
              <li>
                Pihak lainnya telah memberikan informasi yang tidak benar atau
                menyesatkan, atau telah menyembunyikan keadaan penting; atau
              </li>
              <li>
                keadaan keuangan Pihak lainnya telah menurun secara signifikan
              </li>
              <p>
                Di samping itu, Kredivo memiliki hak untuk mengakhiri Perjanjian
                jika:
              </p>
              <li>
                Merchant menawarkan jasa atau barang yang melanggar instruksi
                berlaku Kredivo dari waktu ke waktu; atau
              </li>
              <li>
                Kredivo mencurigainya adanya pelanggaran Perjanjian, dan
                Merchant tidak, tanpa penundaan tidak perlu, memberikan
                informasi yang diminta secara wajar yang penting untuk
                menentukan apakah Merchant telah melanggar Perjanjian.
              </li>
            </ol>
            <p>
              Dalam hal Kredivo mengakhiri Perjanjian berdasarkan bagian 9 ini,
              Kredivo memiliki hak untuk, setelah pemotongan Biaya Transaksi
              atau biaya lain apa pun yang merupakan hak Kredivo untuk
              mengajukan klaim berdasarkan Perjanjian, mengembalikan kepada
              Merchant semua Klaim yang belum dilunasi yang telah diakuisisi dan
              untuk mengajukan klaim atas pengembalian.
            </p>
            <p>
              Merchant mengetahui dan menerima bahwa persyaratan pembayaran yang
              tercakup dalam Kredivo Checkout dapat berubah dari waktu ke waktu
              dan Kredivo dapat menghapus setiap opsi pembayaran apa pun kapan
              saja.
            </p>
          </li>
          <li>
            <b>Hak untuk menahan pembayaran/Pengurangan</b>
            <ol type="a">
              <li>
                Dalam hal pengakhiran oleh salah satu Pihak, Kredivo memiliki
                hak untuk menahan pembayaran lebih lanjut kepada Merchant dan
                menyanggupi penghitungan dan pembayaran final setelah Kredivo
                memeriksa status Klaim- Klaim yang belum dibayar dan batas waktu
                pengembalian telah lewat.
              </li>
              <li>
                Kredivo dapat menahan sementara pembayaran yang sesuai dengan
                jumlah kerugian/peningkatan risiko yang ditimbulkan oleh Kredivo
                jika Merchant secara material atau, setelah adanya peringatan,
                terus menerus gagal untuk memenuhi kewajibannya. Hal tersebut
                juga berlaku jika penjualan Merchant melalui Kredivo menunjukkan
                tingkat pengembalian atau keluhan yang meningkat secara
                signifikan dibandingkan dengan angka historis Merchant. Sebelum
                menahan dana berdasarkan sub bagian (b) ini, Kredivo berjanji
                untuk memberitahukan kepada Merchant alasan penahanan dana.
              </li>
              <li>
                Kredivo dapat menahan sementara pembayaran yang sesuai dengan
                jumlah kerugian/peningkatan risiko jika Kredivo secara wajar
                mencurigai bahwa keadaan keuangan Merchant telah menurun secara
                signifikan yang menyebabkan Merchant tidak mampu memenuhi
                kewajibannya ke Pelanggannya. Kredivo dapat menahan pembayaran
                tersebut sampai Para Pihak menyetujui suatu solusi untuk
                memitigasi risiko atau sampai Merchant telah memberikan bukti
                cukup atas keadaan keuangan yang sehat. Terkait penahanan dana
                berdasarkan sub bagian (c) ini, Kredivo berjanji untuk
                menginformasikan kepada Merchant alasan dana ditahan.
              </li>
              <li>
                Kredivo dapat, atas keputusannya sendiri, mengurangi jumlah apa
                pun yang harus dibayar kepada Merchant dengan klaim apa pun yang
                dimiliki Kredivo terhadap Merchant.
              </li>
            </ol>
          </li>
          <li>
            <b>Keadaan Kahar</b>
            <p>
              Jika Para Pihak tidak dapat memenuhi kewajibannya berdasarkan
              Perjanjian ini karena keadaan di luar kendali Para Pihak –
              contohnya serangan petir, kebakaran, perubahan ketentuan atau
              peraturan hukum yang diberikan oleh otoritas, campur tangan
              otoritas, pemogokan, gangguan komunikasi atau transportasi,
              perubahan nilai tukar atau bencana alam – Para Pihak dibebaskan
              dari tanggung jawabnya sampai keadaan yang mengakibatkan
              ketidakmampuan Para PIhak untuk memenuhi kewajibannya
              masing-masing tidak ada lagi. Bagian 11 ini harus ditafsirkan
              dengan mempertimbangkan bahwa Kredivo memiliki sistem berulang
              dengan tempat server yang tersebar secara geografis. Jika suatu
              Pihak tidak dapat memenuhi kewajibannya dalam jangka waktu lebih
              dari 30 hari karena keadaan apa pun yang disebut di atas, Para
              Pihak memiliki hak, tanpa tanggung jawab untuk membayar
              kompensasi, untuk mengakhiri Perjanjian berlaku segera.
            </p>
          </li>
          <li>
            <b>Tanggung jawab</b>
            <p>
              Jika suatu Pihak tidak memenuhi kewajibannya berdasarkan
              Perjanjian ini, Pihak lainnya berhak untuk mengajukan klaim atas
              kerugian. Tanggung jawab tahunan setiap Pihak untuk membayar
              kompensasi apa pun atau sejenisnya berdasarkan Perjanjian ini
              terbatas sampai jumlah yang lebih besar antara (i) suatu jumlah
              yang sama dengan Biaya Transaksi yang dibayar atau harus
              dibayarkan oleh Merchant kepada Kredivo dalam dua belas (12) bulan
              segera setelah setiap klaim atau (ii) USD 5.000. Kedua Pihak tidak
              bertanggung jawab atas kerugian yang tidak dapat diperkirakan atau
              kerugian yang tidak lazim terjadi untuk Perjanjian ini, dan
              khususnya tidak atas kerugian tidak langsung atau yang diakibatkan
              oleh hal lain. Tanpa mengesampingkan ketentuan di atas, Merchant
              harus mengganti rugi Kredivo sebelumnya dari dan terhadap
              kerugian, klaim atau kerusakan apa pun (termasuk, namun tidak
              terbatas pada, denda dan penalti) yang timbul dari kegagalan untuk
              memenuhi kewajiban informasinya terkait Pelanggan. Di samping itu,
              tanggung jawab Merchant terkait setiap jumlah atau klaim terkait
              pengembalian suatu Klaim berdasarkan bagian 3 atau 9 tunduk kepada
              pembatasan tanggung jawab yang ditetapkan di atas.
            </p>
          </li>
          <li>
            <b>Komunikasi</b>
            <p>
              Pemberitahuan pengakhiran atau korespondensi lain apa pun
              berdasarkan Perjanjian ini diberikan secara tertulis melalui surat
              atau E-mail kepada detail kontak yang diberikan dalam Perjanjian
              Utama atau sebagaimana disetujui secara tertulis dalam bentuk apa
              pun. E-mail kepada Kredivo dikirim ke alamat E-mail berikut:
              merchops@kredivo.com.
            </p>
          </li>
          <li>
            <b>Perubahan Perjanjian</b>
            <p>
              Kredivo berhak untuk secara sepihak mengubah ketentuan Perjanjian
              ini, asalkan Kredivo memberitahukan kepada Merchant perubahan
              tersebut paling tidak 30 hari sebelumnya. Dalam hal tersebut,
              Merchant berhak untuk mengakhiri Perjanjian dengan jangka waktu
              pemberitahuan 30 hari. Pemberitahuan pengakhiran tersebut harus
              dikeluarkan tidak lebih dari 60 hari setelah Merchant menerima
              pemberitahuan atas perubahan.
            </p>
          </li>
          <li>
            <b>Pengalihan</b>
            <p>
              Kedua Pihak tidak dapat mengalihkan hak dan kewajibannya
              berdasarkan Perjanjian ini tanpa persetujuan tertulis sebelumnya
              dari Pihak lainnya. Tanpa mengesampingkan ketentuan di atas,
              Kredivo memiliki hak untuk mengalihkan, menggadaikan atau dengan
              cara apa pun melepaskan Klaim tanpa persetujuan Merchant. Kredivo
              berhak untuk melibatkan subkontraktor untuk menyediakan
              Layanannya.
            </p>
          </li>
          <li>
            <b>Kerahasiaan</b>
            <p>
              Para Pihak berjanji, selama jangka waktu Perjanjian ini dan untuk
              jangka waktu dua (2) tahun setelahnya, tidak akan mengungkapkan
              Informasi Rahasia kepada pihak ketiga manapun tanpa persetujuan
              tertulis Pihak lainnya. “Informasi Rahasia” berarti informasi apa
              pun, dalam bentuk apa pun, yang diungkapkan atau disediakan oleh
              satu Pihak kepada pihak lainnya (“<b>Pihak yang Menerima</b>”)
              dalam konteks Perjanjian ini. Informasi tidak rahasia berarti
              informasi apa pun yang (a) tersedia atau menjadi tersedia secara
              umum bagi publik selain sebagai akibat pengungkapan oleh Pihak
              yang Menerima; (b) Pihak yang Menerima dapat menunjukkan bahwa
              pihaknya telah memiliki informasi tersebut sebelum diterima; (c)
              informasi yang harus diberikan oleh Pihak yang Menerima
              berdasarkan hukum, perintah pengadilan atau keputusan dari
              otoritas pemerintah apa pun yang berlaku; atau (d) informasi yang
              diterima oleh Pihak yang Menerima dari pihak ketiga tanpa terikat
              kerahasiaan terkait dengannya. Untuk menghindari keragu-raguan,
              Informasi Rahasia juga merujuk kepada informasi pihak ketiga yang
              sifatnya teknis, komersil atau lainnya kecuali ada alasan objektif
              dan wajar untuk beranggapan bahwa informasi tersebut tidak
              rahasia. Ketentuan ini berlaku atas informasi apa pun terkait
              pihak ketiga yang didapatkan oleh Merchant ketika menggunakan
              Sistem Pemantauan Pesanan Kredivo atau ketika berkomunikasi dengan
              Kredivo, dan jika jelas bahwa penyebaran informasi tersebut tidak
              diinginkan oleh pihak ketiga.
            </p>
          </li>
          <li>
            <b>Perlindungan data – Pengendali Data Pribadi</b>
            <ol type="a">
              <li>
                <b>Penanganan data Pelanggan </b>
              </li>
              <p>
                Para Pihak setuju dan memahami bahwa keduanya akan bertindak
                secara terpisah sebagai pengendali data terkait data pribadi
                yang diproses olehnya masing-masing sesuai dengan Perjanjian,
                dan bahwa Kredivo akan menjadi pengendali data terkait data apa
                pun yang diterima olehnya dari Pelanggan. Kedua Pihak setuju
                untuk mematuhi hukum privasi berlaku terkait data pribadi yang
                diproses sesuai dengan Perjanjian. Jika, dan sejauh, suatu Pihak
                memproses data pribadi atas nama pihak lainnya, Para Pihak harus
                dengan itikad baik mendiskusikan dan menyetujui suatu perjanjian
                pemrosesan data yang terpisah.
              </p>
              <li>
                <b>Penanganan data kontak Merchant</b>
              </li>
              <p>
                Kredivo akan secara elektronik memproses data pribadi terkait
                kontak Merchant, seperti informasi kontak, untuk memberikan
                Layanan kepada Merchant dan untuk mengelola hubungan bisnis
                dengan Merchant. Data dapat juga digunakan untuk tujuan analisis
                statistik dan pelaporan bisnis, selama investigasi penipuan dan
                untuk mematuhi peraturan perundang-undangan berlaku. Kredivo
                berkomitmen untuk melindungi data pribadi dan akan menggunakan
                sistem perlindungan yang memadai untuk melindungi data.
              </p>
              <li>
                <b>Penanganan data kontak Merchant untuk tujuan pemasaran</b>
              </li>
              <p>
                Kredivo dapat menggunakan data kontak Merchant untuk mengirim
                Buletin, untuk melakukan survei produk, untuk mengiklankan
                produk atau jasa sejenis Kredivo dan untuk undangan acara.
                DENGAN MEMBERIKAN DATA PRIBADI MENGENAI ORANG LAIN MERCHANT
                MENGKONFIRMASI BAHWA PIHAKNYA TELAH SETUJU UNTUK MENGUNGKAPKAN
                DATA TERSEBUT DAN PENGGUNAAN DATA TERSEBUT UNTUK TUJUAN-TUJUAN
                DAN DALAM CARA YANG DIJELASKAN DALAM (b) DAN (c).
              </p>
            </ol>
          </li>
          <li>
            <b>Hak kekayaan intelektual dan pengetahuan teknis</b>
            <p>
              Kredivo memiliki retensi semua kepemilikan dan hak kekayaan
              intelektual atas semua yang dikembangkan oleh Kredivo dan
              diberikan kepada atau diakses oleh Merchant berdasarkan
              Perjanjian. Setelah pengakhiran Perjanjian, Merchant berjanji
              untuk segera menghapus semua logo terkait dan sejenisnya milik
              Kredivo. Kredivo berhak untuk merujuk Merchant sebagai pengguna
              Layanan dalam materi pemasaran, penjualan atau sejenis.
            </p>
          </li>
          <li>
            <b>Hukum dan yurisdiksi mengatur</b>
            <p>
              Perjanjian ini diatur oleh hukum Indonesia. Setiap sengketa atau
              perbedaan didalam atau terkait Perjanjian ini diselesaikan oleh
              pengadilan Indonesia dengan Jakarta sebagai pilihan pertama.
            </p>
          </li>
          <li>
            <b>Klausul keterpisahaan</b>
            <p>
              Jika suatu ketentuan Perjanjian ini menjadi tidak berlaku atau
              tidakdapat diberlakukan, hal ini tidak akan mempengaruhi
              ketentuan-ketentuan lain dan keabsahan Perjanjian ini. Untuk
              menggantikan ketentuan yang tidak sah atau tidak dapat
              diberlakukan, Para PIhak akan memutuskan penggunaan kata dengan
              arti sedekat mungkin dengan arti dan tujuan komersil ketentuan
              tersebut.
            </p>
          </li>
        </ol>
      </ol>
    </div>
  );
};

export default Indonesia;
